import { environment } from '../../environments/environment';

export function isNoMonitorAndProd(): boolean {
  return window?.location?.search !== '?utm_source=monitoring' && environment.environment === 'production';
}
